import { render, staticRenderFns } from "./Contratos.vue?vue&type=template&id=3d88688f&scoped=true&"
import script from "./contratos.js?vue&type=script&lang=js&"
export * from "./contratos.js?vue&type=script&lang=js&"
import style0 from "./Contratos.vue?vue&type=style&index=0&id=3d88688f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d88688f",
  null
  
)

export default component.exports